import s from "../../../uc.micro/categories/P/regex.js";
import c from "../../../uc.micro/categories/S/regex.js";
function t(e) {
  switch (e) {
    case 9:
    case 32:
      return !0;
  }
  return !1;
}
function r(e) {
  if (e >= 8192 && e <= 8202)
    return !0;
  switch (e) {
    case 9:
    case 10:
    case 11:
    case 12:
    case 13:
    case 32:
    case 160:
    case 5760:
    case 8239:
    case 8287:
    case 12288:
      return !0;
  }
  return !1;
}
function u(e) {
  return s.test(e) || c.test(e);
}
function n(e) {
  switch (e) {
    case 33:
    case 34:
    case 35:
    case 36:
    case 37:
    case 38:
    case 39:
    case 40:
    case 41:
    case 42:
    case 43:
    case 44:
    case 45:
    case 46:
    case 47:
    case 58:
    case 59:
    case 60:
    case 61:
    case 62:
    case 63:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 124:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
export {
  n as isMdAsciiPunct,
  u as isPunctChar,
  t as isSpace,
  r as isWhiteSpace
};
